import { DynamicFormV2Palette } from "@mui/material";

export type FormLinkBlockComponentTokenType = {
  textColor: string;
  iconColor: string;
  backgroundColor: string;
  hoverBackgroundColor: string;
};

export const assignLinkBlockComponentTokens = (formsPalette: DynamicFormV2Palette["forms"], mode: "light" | "dark") => {
  const isLightMode = mode === "light";

  return {
    textColor: formsPalette.text.moderate,
    iconColor: formsPalette.text.brand,
    backgroundColor: isLightMode ? formsPalette.surface.reverse : formsPalette.surface.quiet,
    hoverBackgroundColor: formsPalette.surface.hover.quiet,
  } as FormLinkBlockComponentTokenType;
};
